export default __webpack_public_path__ + "static/media/boro-punk-blue-bg.1b1fc806.png";